import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// L corner for the garden hedge: two half-length hedge arms meeting at the
// tile centre (arms toward +X and +Z), same 0.35 x 0.7 profile as
// garden-hedge so straight runs turn cleanly.
const LEAF = "#5f8f4e";
const LEAF_DARK = "#4e7a3e";

export const hedgeCorner = defineModel({
  id: "hedge-corner",
  batchId: "modern",
  name: "Hedge corner",
  tags: ["modern", "outdoor", "garden", "hedge", "plant", "corner"],
  summary: "An L-shaped clipped hedge corner joining two hedge runs.",
  description:
    "The corner piece for garden-hedge: two half-length hedge arms (toward " +
    "+X and +Z) meeting at the tile centre with the same 0.35 x 0.7 profile, " +
    "so perpendicular hedge runs join without a gap.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // Arm toward +X: spans x from -0.175 to 0.5 so the elbow is solid.
      {
        geometry: new THREE.BoxGeometry(0.675, 0.64, 0.35),
        color: LEAF,
        position: [0.1625, 0.32, 0],
      },
      // Arm toward +Z.
      {
        geometry: new THREE.BoxGeometry(0.35, 0.64, 0.675),
        color: LEAF,
        position: [0, 0.32, 0.1625],
      },
      // Darker clipped crowns matching garden-hedge.
      {
        geometry: new THREE.BoxGeometry(0.675, 0.06, 0.37),
        color: LEAF_DARK,
        position: [0.1625, 0.67, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.37, 0.06, 0.675),
        color: LEAF_DARK,
        position: [0, 0.67, 0.1625],
      },
    ];
  },
  animations: [],
});
